import { Link } from 'react-router-dom'
import type { Problem } from '../api/problem'

/**
 * An RFC 9457 problem, read by a person rather than a program.
 *
 * The API's messages are written to be shown: an unknown points table names
 * the real ones, an unknown driver names the slug it did not recognise. So the
 * detail is displayed verbatim instead of being replaced with "an error
 * occurred", and the trace id is shown when there is one, because that is the
 * only thing worth quoting in a bug report.
 */
export function ProblemBanner({
  problem,
  onRetry,
}: {
  problem: Problem
  onRetry?: () => void
}) {
  return (
    <div className="problem" role="alert">
      <strong>{problem.title}</strong>
      <p>{problem.detail}</p>
      {problem.errors && problem.errors.length > 0 ? (
        <ul className="problem__fields">
          {problem.errors.map((entry, index) => (
            <li key={index}>
              <code>{entry.loc.filter((part) => part !== 'query').join('.')}</code> {entry.msg}
            </li>
          ))}
        </ul>
      ) : null}
      <p className="problem__exits">
        {onRetry ? (
          <button type="button" onClick={onRetry}>
            Try again
          </button>
        ) : null}{' '}
        <Link to="/">Start over</Link>
        {problem.trace_id ? <span className="muted"> · trace {problem.trace_id}</span> : null}
      </p>
    </div>
  )
}
